import { IUser } from '../services/api-services/UsersServices'
import { IRequest } from '../services/api-services/RequestsServices'
import { IRolAlternativo } from '../services/api-services/InterinosServices'
import { IArmador } from '../services/api-services/ArmadoresServices'
import { IEmbarcacion } from '../services/api-services/EmbarcacionesServices'

export enum EsporadicoEstado {
  SOLICITADO = 'solicitado',
  VIGENTE = 'vigente',
  CADUCADO = 'caducado',
  REVOCADO = 'revocado',
  RECHAZADO = 'rechazado',
  SIN_SOLICITUDES = 'sin_solicitudes',
}

/**
 * Vista derivada de un esporádico — composición de IUser (rol=7) + sus solicitudes.
 *
 * Modelo de solicitudes (ver §"Modelo de solicitudes" en docs/evolutivo-esporadicos.md):
 *   - solicitudBase: tipo='esporadico' + id_objeto_2 NULL. Una sola por esporádico,
 *     creada automáticamente al inscribirlo. Representa "validez como persona".
 *   - solicitudesTrabajo: tipo='esporadico' + id_objeto_2 = RolAlternativoID (FK).
 *     Una por visita (NO se renuevan, se crean nuevas). Ordenadas desc por fecha.
 *   - solicitudesAsociacionArmador: tipo='asociacion_esporadico' + tipo_objeto_2='armador'.
 *   - solicitudesAsociacionEmbarcacion: tipo='asociacion_esporadico' + tipo_objeto_2='embarcacion'.
 *     Por cada solicitud de trabajo hay 1 o 2 asociaciones (al menos una; pueden coexistir).
 *
 * `ultimaSolicitudTrabajo` es la última solicitud de trabajo (no la base). `esVigente`
 * se calcula sobre ella. `rolAlternativoData` se resuelve cruzando id_objeto_2 con el
 * bucket ROLES_ALTERNATIVOS (incluye horario, logica_credencial, etc.).
 */
export interface IEsporadicoView extends IUser {
  solicitudBase: IRequest | undefined
  solicitudesTrabajo: IRequest[]
  trabajosActivos: IRequest[] // subconjunto de solicitudesTrabajo APPROVED con caducidad futura (vigentes ahora)
  solicitudesAsociacionArmador: IRequest[]
  solicitudesAsociacionEmbarcacion: IRequest[]
  ultimaSolicitudTrabajo: IRequest | undefined
  ultimasAsociacionArmador: IRequest[] // asociaciones armador pareadas con la última solicitud de trabajo
  ultimasAsociacionEmbarcacion: IRequest[] // asociaciones embarcación pareadas con la última solicitud de trabajo
  idRolAlternativo: number | undefined // FK del cargo en la última solicitud de trabajo
  rolAlternativoData: IRolAlternativo | undefined // resuelto contra bucket ROLES_ALTERNATIVOS
  ultimosArmadores: IArmador[] // armadores resueltos contra bucket ARMADORES (última visita)
  ultimasEmbarcaciones: IEmbarcacion[] // embarcaciones resueltas contra bucket EMBARCACIONES (última visita)
  esVigente: boolean // derivado: existe AL MENOS UN trabajo activo (APPROVED + fecha_caducidad > now)
  estado: EsporadicoEstado
}

export const defaultIEsporadicoView: IEsporadicoView = {
  id_usuario: 0,
  rut: '',
  nombre_completo: '',
  email: '',
  rol: 7,
  vigente: 0,
  notificar: null,
  bloqueo: 0,
  bloqueo_fecha: '',
  clave: '',
  telefono: '',
  id_gestor_fotografia: 0,
  id_gestor_ci: 0,
  solicitudBase: undefined,
  solicitudesTrabajo: [],
  trabajosActivos: [],
  solicitudesAsociacionArmador: [],
  solicitudesAsociacionEmbarcacion: [],
  ultimaSolicitudTrabajo: undefined,
  ultimasAsociacionArmador: [],
  ultimasAsociacionEmbarcacion: [],
  idRolAlternativo: undefined,
  rolAlternativoData: undefined,
  ultimosArmadores: [],
  ultimasEmbarcaciones: [],
  esVigente: false,
  estado: EsporadicoEstado.SIN_SOLICITUDES,
}
